export const APP_DOMAIN = `/`;
export const APP_LOGIN = `${APP_DOMAIN}login`;
export const APP_RECOVERY = `${APP_DOMAIN}recovery`;
export const APP_SET_NEW_PASSWORD = `${APP_DOMAIN}setNewPassword`;
export const APP_BUSINESS_DOMAIN = `${APP_DOMAIN}business`;
export const APP_CANDIDATE_DOMAIN = `${APP_DOMAIN}candidate`;
export const APP_MIDDLEWARE = `${APP_DOMAIN}middleware`;
export const COMMON_COMPONENT = `${APP_DOMAIN}components`;
